import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Info, FileText } from "lucide-react";
import purchase_certificate from "../../assets/documents/purchase_certificate.pdf";
import declarationDocument from "../../assets/documents/declaration.pdf";
import supplierListDocument from "../../assets/pdf/empanel_list.pdf";

export default function UploadRequirementsDialog({
  openModal,
  setOpenModal,
  uploads_array,
}) {
  const renderNotes = (notes) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = notes.split(urlRegex);

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline break-all"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  const handleDownload = (type) => {
    let fileUrl;
    let fileName;
    if (type == "undertaking") {
      fileUrl = purchase_certificate;
      fileName = "purchase_certificate.pdf";
    }
    if (type == "declaration") {
      fileUrl = declarationDocument;
      fileName = "declaration_document.pdf";
    }
    if (type == "supplier_list") {
      fileUrl = supplierListDocument;
      fileName = "supplier_list.pdf";
    }
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    link.click();
  };

  return (
    <Dialog
      open={openModal}
      onOpenChange={(value) => {
        if (!value) return;
      }}
    >
      <DialogContent
        disableCloseButton
        className="w-[90%] h-[80%] lg:max-w-2xl"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-800">
            Requirements to Complete the Application
          </DialogTitle>
        </DialogHeader>

        <p className="text-gray-600 text-sm leading-relaxed mb-3">
          <Info className="inline w-4 h-4 mr-1 text-blue-500" />
          Before filling the application, please make sure that you have the
          required documents mentioned below.
        </p>

        <div className="max-h-[60vh] overflow-y-auto pr-2 pb-2">
          <ul className="space-y-4">
            {uploads_array.map((item, index) => (
              <li
                key={index}
                className="bg-gray-50 hover:bg-gray-100 p-3 rounded-xl border border-gray-200 shadow-sm transition-all"
              >
                <div className="flex items-start gap-2">
                  <FileText className="w-5 h-5 text-indigo-500 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-800">
                      {item.name}
                      <span className="block text-xs text-gray-500 font-normal mt-0.5">
                        ({item.type})
                      </span>
                    </p>
                    {item.file && (
                      <div className="mt-2 rounded-md p-2 text-sm text-gray-700 cursor-pointer">
                        <b
                          className="text-blue-700"
                          onClick={() => handleDownload(item.file)}
                        >
                          Click Here to download
                        </b>
                      </div>
                    )}
                    {item.notes && (
                      <div className="mt-2 bg-blue-50 border-l-4 border-blue-400 rounded-md p-2 text-sm text-gray-700">
                        <b className="text-blue-700">Notes:</b>{" "}
                        <span className="text-gray-700 leading-relaxed">
                          {renderNotes(item.notes)}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <DialogFooter className="mt-5">
          <Button
            type="button"
            className="w-24 bg-indigo-600 hover:bg-indigo-700 text-white"
            onClick={() => setOpenModal(false)} // ✅ Only this closes the modal
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
